import { ROLE_CLIENT } from "config/constants";
import { deleteData, getData, patchData, postData } from "./base";

const endPoints = {
  login: "/auth/admin-login",
  loginCode: "/auth/login-with-code",
  profile: "/users/profile",
  users: "/users",
  locations: "/locations",
  presignedUrls: "/locations/presigned-urls",
  settings: "/settings",
  documents: "/documents",
  importUsers: '/users/imports',
  documentlabels: "/document-labels",
  maintenance: "/maintenance",
  password_email: "/auth/send-password-reset",
  reset_password: "/auth/reset-password"
};

const login = (payload) =>
  new Promise((resolve, reject) => {
    postData(endPoints.login, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const loginCode = (payload) =>
  new Promise((resolve, reject) => {
    postData(endPoints.loginCode, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const getProfile = () =>
  new Promise((resolve, reject) => {
    getData(endPoints.profile)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

// Users
const listUsers = (params) =>
  new Promise((resolve, reject) => {
    const query = Object.keys(params)
      .filter((key) => params[key] != null && params[key] !== "")
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join("&");
    getData(endPoints.users + (query ? "?" + query : ""))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

const listAllUsers = (params) => listUsers(params);

const listClients = () => listAllUsers({ role: ROLE_CLIENT });

const listRelatedUsers = (params) =>
  new Promise((resolve, reject) => {
    const query = Object.keys(params)
      .filter((key) => params[key])
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join("&");
    getData(endPoints.users + "/related-users?" + query)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

const createUser = (payload) =>
  new Promise((resolve, reject) => {
    postData(endPoints.users, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

const getUser = (id) =>
  new Promise((resolve, reject) => {
    getData(endPoints.users + "/" + id)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

const updateUser = (id, payload) =>
  new Promise((resolve, reject) => {
    patchData(endPoints.users + "/" + id, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const updateUserPermission = (id, payload) =>
  new Promise((resolve, reject) => {
    postData(endPoints.users + "/" + id, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const removeUser = (id) =>
  new Promise((resolve, reject) => {
    deleteData(endPoints.users + "/" + id)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

const changePassword = (payload) =>
  new Promise((resolve, reject) => {
    postData(endPoints.users + "/change-password", payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

const uploadDocuments = (clientId, formData) =>
  new Promise((resolve, reject) => {
    postData(endPoints.documents + "/" + clientId, formData)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const generateQRCode = (clientId, formData) =>
  new Promise((resolve, reject) => {
    patchData(endPoints.documents + "/" + clientId, formData)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const listDocuments = (params) =>
  new Promise((resolve, reject) => {
    const query = Object.keys(params)
      .filter((key) => params[key])
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join("&");
    getData(endPoints.documents + "?" + query)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const listQRcodes = (params) =>
  new Promise((resolve, reject) => {
    const query = Object.keys(params)
      .filter((key) => params[key])
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join("&");
    getData(endPoints.documents + "/qrcodes?" + query)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const removeDocument = (payload) =>
  new Promise((resolve, reject) => {
    deleteData(endPoints.documents, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const importUsers = payload =>
  new Promise((resolve, reject) => {
    postData(endPoints.importUsers, payload)
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
const createDocumentLabel = (payload) =>
  new Promise((resolve, reject) => {
    postData(endPoints.documentlabels, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const listDocumentLabels = (params) =>
  new Promise((resolve, reject) => {
    const query = Object.keys(params)
      .filter((key) => params[key])
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join("&");
    getData(endPoints.documentlabels + "?" + query)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

const getMaintenance = (params) =>
  new Promise((resolve, reject) => {
    getData(endPoints.maintenance)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
const updateMaintenance = (payload) =>
  new Promise((resolve, reject) => {
    postData(endPoints.maintenance, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

const sendResetPasswordLink = body =>
  new Promise((resolve, reject) => {
    postData(endPoints.password_email, { ...body })
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
  const resetPassword = body =>
    new Promise((resolve, reject) => {
      postData(endPoints.reset_password, { ...body })
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
const api = {
  login,
  loginCode,
  getProfile,
  listClients,
  changePassword,
  listUsers,
  listAllUsers,
  getUser,
  updateUser,
  updateUserPermission,
  removeUser,
  createUser,
  listRelatedUsers,
  uploadDocuments,
  generateQRCode,
  listDocuments,
  listQRcodes,
  removeDocument,
  importUsers,
  createDocumentLabel,
  listDocumentLabels,
  getMaintenance,
  updateMaintenance,
  sendResetPasswordLink,
  resetPassword
};

export default api;
